import React, { Fragment } from 'react';

import styled from "styled-components";

const Wrapper = styled.div.attrs(props => ({
    width: props.width || "75%"
}))`
    display: flex;
    flex-flow: column nowrap;
    margin: 0 0 10px 0;
    width: ${props => props.width};

    label {
        padding-top: 1.4em;
        line-height: 1.4em;

        :after {
            content: "*";
            color: #ff6b6b;
            display: inline-block;
            margin-left: .3em;
            line-height: 1;
        }
    }

`

const StyledTextArea = styled.textarea`
    min-height: 140px;
    padding: 10px;    
    background-color: #f2f2ff;
    font-size: 1rem;
    font-weight: 300;
    font-family: inherit;
    border: none;
    border-bottom: solid 2px #8080ff;
    border-radius: 0;

    :focus {
        outline: 0;
    }
`

const Error = styled.p`
    color: ${props => props.theme.codanColors.codanErrorRed};
    font-size: 12px; 
`

const LabelledTextareaValidated = ({
    placeholder,
    name,
    onChange,
    errors,
    values,
    isStrong,
    labelText,
    ...props
}) => {
    return (
        <Wrapper {...props}>
            <label>
                {isStrong ? <strong>{labelText}</strong> : labelText}
            </label>

            <StyledTextArea
                name={name}
                placeholder={placeholder}
                onChange={onChange}
                value={values[name] || ''}
            />
            {errors[name] && (
                <Error>{errors[name]}</Error>
            )}
        </Wrapper>
    )
}

export default LabelledTextareaValidated;